<template>
  <div>
    <h2 :class="currentPageIndex === 5 ? 'h6' : 'h4'">Dine valg</h2>

    <div class="summary">
      <div v-if="selectedAddress" class="summary__line">
        <span class="summary__line--key">Adresse</span>
        <span class="summary__line--value">
          {{ selectedAddress.gatenavn }} {{ selectedAddress.husNr
          }}{{ selectedAddress.husBokstav }}, {{ selectedAddress.postNummer }}
          {{ selectedAddress.postSted }}
        </span>
      </div>
      <div class="summary__line">
        <span class="summary__line--key">Kundetype</span>
        <span class="summary__line--value">{{ customerType.name }}</span>
      </div>
      <div
        v-if="allSelectPagesVisited || (currentPageIndex >= 2 && roofType.name)"
        class="summary__line"
      >
        <span class="summary__line--key">Taktype</span>
        <span class="summary__line--value">{{ roofType.name }}</span>
      </div>
      <div
        v-if="
          allSelectPagesVisited || (currentPageIndex >= 3 && panelType.name)
        "
        class="summary__line"
      >
        <span class="summary__line--key">Type panel</span>
        <span class="summary__line--value"
          >{{ panelType.name }} - {{ panelType.description }}</span
        >
      </div>
      <div
        v-if="
          allSelectPagesVisited ||
          (currentPageIndex >= 3 && panel.antallPaneler)
        "
        class="summary__line"
      >
        <span class="summary__line--key">Antall panel</span>
        <span class="summary__line--value">{{ panel.antallPaneler }}</span>
      </div>
    </div>

    <div v-if="currentPageIndex === 4" class="info-box">
      Det er stor interesse rundt solkraft nå, og vi må derfor informere om at
      leveringstiden er lenger enn vanlig. Vi ber også om tålmodighet om det tar
      lang tid å få svar fra oss.
    </div>
    <h2 v-if="currentPageIndex === 5" class="h6">Kontaktinfo</h2>
    <div v-if="currentPageIndex === 5" class="summary">
      <div class="summary__line">
        <span class="summary__line--key">Navn</span>
        <span class="summary__line--value">{{
          customerInformation.fullName
        }}</span>
      </div>
      <div class="summary__line">
        <span class="summary__line--key">Telefon</span>
        <span class="summary__line--value">{{
          customerInformation.phoneNumber
        }}</span>
      </div>
      <div class="summary__line">
        <span class="summary__line--key">E-post</span>
        <span class="summary__line--value">{{
          customerInformation.email
        }}</span>
      </div>
      <div class="summary__line">
        <span class="summary__line--key">Postadresse</span>
        <span class="summary__line--value">{{
          customerInformation.address
        }}</span>
      </div>
      <div class="summary__line">
        <span class="summary__line--key">Postnummer og sted</span>
        <span class="summary__line--value">
          {{ customerInformation.postalCode }}
          {{ customerInformation.postalArea }}
        </span>
      </div>
      <div class="summary__line">
        <span class="summary__line--key">Kommentar</span>
        <span class="summary__line--value">{{
          customerInformation.comment
        }}</span>
      </div>
    </div>

    <h2 :class="currentPageIndex === 5 ? 'h6' : 'h4'">Pris</h2>
    <div v-if="panel.kwtAar" class="summary">
      <div
        class="summary__line"
        v-if="customerType.value === 'privat' && panel.fullPrice"
      >
        <span class="summary__line--key">Ordinær pris</span>
        <span class="summary__line--value">
          {{ panel.fullPrice | Thousands }}
          kr
        </span>
      </div>

      <div
        class="summary__line summary__line-sum"
        v-if="customerType.value === 'privat' && panel.fullPrice"
      >
        <span class="summary__line--key">Kampanjerabatt</span>
        <span class="summary__line--value"
          >{{ (panel.pris - panel.fullPrice) | Thousands }} kr</span
        >
      </div>

      <div
        class="summary__line noBorder"
        :class="{
          'summary__line-sum': customerType.value !== 'privat',
        }"
      >
        <span class="summary__line--key">
          {{
            customerType.value === 'privat'
              ? 'Pris å betale'
              : 'Totalt eks. mva.'
          }}
        </span>
        <span class="summary__line--value">
          {{
            customerType.value === 'privat'
              ? panel.pris
              : panel.pris_ex_mva | Thousands
          }}
          kr
        </span>
      </div>

      <div class="summary__line italic" v-if="customerType.value === 'privat'">
        <span class="summary__line--key">Rentefri delbetaling over 5 år</span>
        <span class="summary__line--value">
          {{ (panel.pris / 60) | Thousands }}
          kr/md.
        </span>
      </div>

      <div class="summary__line" v-if="customerType.value === 'privat'">
        <span class="summary__line--key">Enova-støtte</span>
        <span class="summary__line--value"
          >- {{ panel.enovaStotte | Thousands }} kr</span
        >
      </div>

      <div class="summary__line" v-if="discountCodeMatch">
        <span class="summary__line--key">Rabatt</span>
        <span class="summary__line--value">{{ discount | Thousands }} kr</span>
      </div>

      <div
        class="summary__line summary__line-sum"
        v-if="customerType.value === 'privat'"
      >
        <span class="summary__line--key">Totalt etter Enova-støtte</span>
        <span class="summary__line--value">
          {{
            !discountCodeMatch
              ? panel.pris - panel.enovaStotte
              : (panel.pris - panel.enovaStotte - discount) | Thousands
          }}
          kr
        </span>
      </div>
    </div>
    <p v-else>Gå videre for prisestimat.</p>
  </div>
</template>

<script>
import store from '../store';
import Money from '../filters/Money';
import Thousands from '../../common/filters/Thousands';
export default {
  name: 'OfferInformation',
  filters: {
    Money,
    Thousands,
  },
  data() {
    return {
      discountCode: store.state.discountCode,
    };
  },
  watch: {},
  methods: {},
  computed: {
    currentPageIndex() {
      return store.state.currentPageIndex;
    },
    customerType() {
      return store.state.CustomerType;
    },
    customerInformation() {
      return store.state.CustomerInformation;
    },
    roofType() {
      return store.state.roofType;
    },
    panel() {
      return store.state.panelsVal;
    },
    panelType() {
      return store.state.solarPanelType;
    },
    offer() {
      return store.state.offer;
    },
    discountCodeUserInput() {
      return store.state.discountCodeUserInput;
    },
    discountCodeMatch() {
      return (
        this.discountCodeUserInput.trim().toLowerCase() === this.discountCode
      );
    },
    discount() {
      return store.state.discount;
    },
    selectedAddress() {
      return store.state.selectedAddress;
    },
    allSelectPagesVisited() {
      return (
        store.state.pages[0].visited &&
        store.state.pages[1].visited &&
        store.state.pages[2].visited &&
        store.state.pages[3].visited
      );
    },
  },
};
</script>

<style scoped>
.h4 + p {
  font-size: 16px;
}

.summary__line {
  display: flex;
  justify-content: space-between;
}

.summary__line .summary__line--value {
  text-align: right;
}

.summary__line.noBorder {
  border: none;
}

.summary__line.italic {
  font-style: italic;
}

.info-box {
  background-color: white;
  color: #333;
  border-radius: 0.1em;
  padding: 1em;
  margin-top: 2em;
  text-align: left;
  font-size: 13px;
}
</style>
